export const settingsConstants = {
    GRAYSCALE_IMAGES: "GRAYSCALE_IMAGES",
    CHANGE_FILTER: "CHANGE_FILTER",
    UNMUTE_PRESSED: "UNMUTE_PRESSED",
    CHANGE_INTERACTION_METHOD: "CHANGE_INTERACTION_METHOD",
    CHANGE_NUMBERS_MODE: "CHANGE_NUMBERS_MODE",
};